import SEO from '../components/SEO';
import PageLayout from '../components/PageLayout';
import { SITE, STATS } from '../lib/site';
import { Link } from 'react-router-dom';
import { HardHat, UserCheck, FileCheck2, ShieldCheck } from 'lucide-react';

const values = [
  {
    icon: HardHat,
    title: 'Equipos propios',
    text: 'Oficiales y peones de la provincia, en nómina. Sin encadenar subcontratas: quien presupuesta, ejecuta y responde.',
  },
  {
    icon: UserCheck,
    title: 'Trato directo',
    text: 'Hablas con Hugo o con el jefe de obra, no con un call center. Un interlocutor único de principio a fin.',
  },
  {
    icon: FileCheck2,
    title: 'Contrato claro',
    text: 'Presupuesto desglosado, plazos por escrito y garantía de 10 años. Lo que firmamos es lo que entregamos.',
  },
  {
    icon: ShieldCheck,
    title: 'Seguridad ante todo',
    text: 'Seguro de responsabilidad civil, plan de prevención y trabajo limpio en viviendas habitadas.',
  },
];

const Nosotros = () => {
  return (
    <PageLayout
      label="Sobre HGO"
      title="Construcción de"
      titleEm="toda la vida"
      lead={`${SITE.name} nace en ${SITE.founded} de la mano de ${SITE.founder}, oficial de obra de oficio. Más de 150 proyectos después, seguimos trabajando igual: con las manos en la obra y la palabra como contrato.`}
      crumbs={[{ name: 'Nosotros' }]}
    >
      <SEO
        title="Nosotros — HGO Servicios, Constructores en Málaga desde 2009"
        description="Conoce a HGO Servicios: empresa familiar de construcción y reformas en Málaga fundada por Hugo Caballero. Equipos propios, garantía de 10 años y +150 proyectos entregados."
        url="/nosotros"
        breadcrumbs={[{ name: 'Inicio', url: '/' }, { name: 'Nosotros', url: '/nosotros' }]}
      />

      {/* Stats */}
      <section className="max-w-[1400px] mx-auto px-6 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 border-y border-line py-10">
          {STATS.map((s) => (
            <div key={s.label} className="reveal text-center md:text-left">
              <p className="stat-number text-4xl md:text-5xl">
                {s.value}<span className="text-clay">{s.suffix}</span>
              </p>
              <p className="mt-2 text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-ink-faint">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Historia */}
      <section className="max-w-[1400px] mx-auto px-6 pb-20">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <div className="reveal space-y-5 text-ink-soft leading-relaxed">
            <h2 className="font-display font-black uppercase tracking-tight text-section-title text-ink">
              De oficial a <em className="font-serifit normal-case font-normal text-clay">empresa</em>
            </h2>
            <p>
              Hugo Caballero empezó como oficial de albañilería a los 18 años, aprendiendo
              el oficio en obras de Málaga capital. En {SITE.founded} montó {SITE.name}
              con una furgoneta, dos oficiales y una idea: <strong className="text-ink font-semibold">hacer obras
              como le gustaría que le hicieran la suya</strong>.
            </p>
            <p>
              Quince años después, el equipo ha crecido a oficiales, jefes de obra y
              auxiliares propios, y hemos entregado más de 150 proyectos entre reformas
              integrales, obra nueva, locales comerciales y mantenimiento de comunidades.
              Pero la forma de trabajar sigue siendo la misma: presencia en obra,
              comunicación diaria y cero excusas.
            </p>
            <p>
              Hoy HGO Servicios es una de las empresas de construcción mejor valoradas
              de la provincia (4,9/5 en más de 87 reseñas), y seguimos rechazando
              trabajos cuando no podemos cumplir plazos. Preferimos decir que no a
              prometer lo que no vamos a cumplir.
            </p>
            <blockquote className="border-l-[3px] border-clay pl-6 italic text-ink text-lg font-medium mt-8">
              “En esta casa no hay obras perfectas, hay obras hechas con palabra:
              lo que te digo en la visita, es lo que encuentras en la entrega.”
              <footer className="not-italic text-sm text-ink-faint mt-2 font-semibold uppercase tracking-[0.14em]">— Hugo Caballero, fundador</footer>
            </blockquote>
          </div>

          <div className="reveal space-y-5">
            {values.map((v) => (
              <div key={v.title} className="flex gap-5 bg-paper-2 border border-line rounded-[4px] p-6">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-ink text-clay-light shrink-0">
                  <v.icon size={19} />
                </span>
                <div>
                  <h3 className="font-display font-bold tracking-tight uppercase text-base">{v.title}</h3>
                  <p className="mt-1.5 text-sm text-ink-soft leading-relaxed">{v.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA interno */}
        <div className="reveal mt-16 flex flex-col sm:flex-row items-center justify-between gap-6 bg-ink text-paper rounded-[4px] px-8 py-9">
          <div>
            <h2 className="font-display font-black uppercase tracking-tight text-2xl">¿Trabajamos juntos?</h2>
            <p className="text-paper/60 text-sm mt-2">Visita gratis, presupuesto en 24h y sin compromiso.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <Link to="/presupuesto" className="btn bg-clay text-white">Pedir presupuesto</Link>
            <Link to="/galeria" className="btn border border-paper/30 text-paper">Ver proyectos</Link>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Nosotros;
